import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";

import NoPic from "../../Assets/Images/emptypic.png"
import {useNavigate} from "react-router-dom";
import {FaUserEdit} from "react-icons/fa";
import {IoMdHelpBuoy} from "react-icons/io";
import {BsChevronCompactLeft, BsInfoCircleFill,  BsWallet2} from "react-icons/bs";
import {GoShieldCheck, GoSignIn, GoSignOut, GoStar} from "react-icons/go";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Loading from "../../Layouts/Loading";
import {MdRuleFolder} from "react-icons/md";
import {FcInvite} from "react-icons/fc";
import {TbMapPinHeart} from "react-icons/tb";
import StarRating from "./StarRating";
import {RiMoneyDollarCircleLine} from "react-icons/ri";
import ScoreStars from "./ScoreStars";

const currencyFormat = Intl.NumberFormat('en-US');

export default function Profile() {
    const navigate = useNavigate();


    const [user , setUser] = React.useState([]);
    const [hasToken , setHasToken] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(true);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(token) {
            setHasToken(true)
            setIsLoaded(false);

            API.getUserInfo()
                .then((response) => {
                    setIsLoaded(true);
                    setUser(response.data.user);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }


    return (
        <React.Fragment>

            <Header title='حساب من' hasBack={false} />
            {
                !isLoaded && <Loading />
            }
            <main className="container-fluid mt-3 py-5 mb-5">
                <div className="row px-3 ">
                    <div className="col-12 rtl profile-header" >
                        <div className="card-body pt-4">
                            <div className="row pb-4" >
                                <div className="col-3">
                                    <img src={user.avatar ? user.avatar : NoPic } className="rounded-circle mx-auto d-block" alt={user.first_name} width="50px" height="50px"/>
                                </div>
                                <div className="col-9">
                                    {
                                        hasToken? <div className=" fw-bold pt-2">{user.name} {user.surname}


                                        </div>
                                            :
                                            <div className=" fw-bold pt-2">کاربر میهمان</div>
                                    }

                                    <span className=" super-small-2 ltr">
                                            {user.username ? user.username.replace('+98' , '0') : ''}
                                        </span>
                                    {
                                        hasToken &&
                                            <div className="profile-edit-user"
                                                 onClick={()=>navigate('/edit-profile')}
                                            >
                                                ویرایش
                                                &nbsp;
                                                <FaUserEdit className='text-big'/>
                                            </div>
                                    }
                                </div>
                                {user?.credit_status?.length > 0 &&
                                <div className="col-12">
                                    <div className='row border-top pt-3 mt-3'>
                                        <div className="col-9 text-end text-small-1 text-dark fw-bold pt-3">
                                            <GoShieldCheck className='ms-2' />
                                                وضعیت در گروه استعلام:
                                                      <span className='fw-bold me-1 mt-2 text-dark text-start'>
                                                {user?.credit_status[0].name}
                                            </span>
                                        </div>
                                        <div className="col-3 text-start text-small-2 p-1">
                                            <img src={user?.credit_status[0].image} alt={user?.credit_status[0].name} title={user?.credit_status[0].name} width={50} height={50} style={{objectFit: 'contain'}}/>

                                        </div>

                                    </div>
                                </div>
                                }
                                {user?.orders_score?.total_ratings > 0 &&
                                <div className="col-12">
                                    <div className='row border-top py-3 mt-1'>
                                        <div className="col-8 text-end text-small-1 text-dark fw-bold pt-1">
                                            <GoStar className='ms-2' />
                                            امتیاز:
                                            {" "}
                                            <b>{user?.orders_score?.average_score}</b>
                                            {" "}
                                            <div className='text-small-3 mt-2 text-end me-4'>
                                                (از
                                                {" "}
                                                {user?.orders_score?.total_ratings}
                                                {" "}
                                                سفارش)
                                            </div>

                                        </div>
                                        <div className="col-4 text-start text-small-2 p-1">

                                            <div className='d-flex justify-content-end'>

                                                <StarRating score={user?.orders_score?.average_score}/>




                                            </div>


                                        </div>

                                        <div className="col-12">
                                            <ScoreStars score_counts={user?.orders_score?.score_counts} />
                                        </div>

                                    </div>
                                </div>
                                }

                                {user?.orders_average_payment?.count > 0 &&
                                    <div className="col-12 ">
                                        <div className='row border-top pt-3 mt-1'>
                                            <div className="col-8 text-end text-small-1 text-dark fw-bold pt-1">
                                                <RiMoneyDollarCircleLine className='ms-2'/>
                                                میانگین مبالغ سفارش ها:
                                                <div className='text-small-3 mt-2 text-end me-4'>
                                                    (از
                                                    {" "}
                                                    {user?.orders_average_payment?.count}
                                                    {" "}
                                                    سفارش تحویل شده

                                                    )

                                                </div>

                                            </div>
                                            <div className="col-4 text-start text-small-2 p-1">

                                                <div className='d-flex justify-content-end ps-3'>

                                                    <strong>{currencyFormat.format(user?.orders_average_payment?.average)}</strong>

                                                    {" "}

                                                    ریال


                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                }


                            </div>

                        </div>
                    </div>

                </div>

                <div className="container-fluid profile-list-items">
                    {
                        !hasToken &&
                        <div className="row mt-4 rtl px-4 menu-list-item " onClick={() => navigate('/login')}>

                            <div className="col-1">
                                <GoSignIn className="text-success"/>
                            </div>
                            <div className="col-10  menu-text text-success">
                                وارد شوید
                            </div>
                            <div className="col-1">
                                <BsChevronCompactLeft/>
                            </div>

                        </div>
                    }
                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={() => navigate('/contents/درباره-ما')}>

                        <div className="col-1">
                            <BsInfoCircleFill className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                            درباره پخش من
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft/>
                        </div>

                    </div>

                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={() => navigate('/contents/قوانین')}>

                    <div className="col-1">
                            <MdRuleFolder className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                             قوانین و مقررات
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/addresses')} >

                        <div className="col-1">
                            <MdRuleFolder className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                            مدیریت آدرس ها
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/favorites/vendors')} >

                        <div className="col-1">
                            <TbMapPinHeart className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                             شرکت های مورد علاقه
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/wallet')} >

                        <div className="col-1">
                            <BsWallet2 className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                            کیف پول
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/profile/invite-others')} >

                        <div className="col-1">
                            <FcInvite className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                            دعوت دیگران به پخش من
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                    <div className="row mt-4 rtl px-4 menu-list-item" onClick={()=>navigate('/contents/تماس-پشتیبانی')} >

                        <div className="col-1">
                            <IoMdHelpBuoy className="text-secondary"/>
                        </div>
                        <div className="col-10 text-dark menu-text ">
                            تماس با پشتیبانی
                        </div>
                        <div className="col-1">
                            <BsChevronCompactLeft />
                        </div>

                    </div>
                    {
                        hasToken &&
                        <div className="row mt-4 rtl px-4 menu-list-item border-bottom-0" onClick={onExitClick}>

                            <div className="col-1">
                                <GoSignOut className="text-secondary"/>
                            </div>
                            <div className="col-10 text-dark menu-text ">
                                خروج از حساب کاربری
                            </div>
                            <div className="col-1">
                                <BsChevronCompactLeft/>
                            </div>

                        </div>
                    }
                    <div className='row mt-4'>
                        <div className="col-12 text-center text-small-3 fw-bold opacity-75">
                            <a className='text-muted opacity-50 text-decoration-none' rel="noreferrer" href="http://www.idmt.ir/?external=true&from=PakhshMan" target='_blank'>
                            Powered By IDMT.ir
                            </a>
                        </div>
                    </div>
                </div>

            </main>
            <Navbar  />
        </React.Fragment>
    );

}

